export default __webpack_public_path__ + "static/media/management-orders-fill-icon.6637bfba.svg";